export default __webpack_public_path__ + "static/media/img-nula-radio-logo.bfb68b94.png";